import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DmCoreErrorType } from '#src/types/DMCoreTypes'

export default class DMCoreError extends BaseError<DmCoreErrorType> {
  constructor(
    public message: string,
    public code: DmCoreErrorType,
    public options?: {
      cause: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMCoreError.prototype)
    this.name = this.constructor.name
  }
}
